import { createAction } from "redux-actions";
import { GET_MENU, UPDATE_MENU, UPDATE_MENU_AGREEMENTS } from "../constants";

export const getMenu = createAction(GET_MENU, (menuJson) => (menuJson))
export const updateMenu = createAction(UPDATE_MENU, (menuJson) => menuJson)
export const updateMenuAgreements = createAction(UPDATE_MENU_AGREEMENTS, (agreement) => agreement)